import React, { useState } from 'react';
import API from '../../API';

const AddNewEvent = ({ accessToken, userId, onEventCreated }) => {
  const [title, setTitle] = useState('');
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title.trim()) {
      setError('Title is required');
      return;
    }

    setIsCreating(true);
    setError(null);

    try {
      const response = await API.adminCreateEvent(accessToken, {
        title: title.trim()
      });

      if (response.status === 201) {
        setTitle('');
        setIsExpanded(false);
        if (onEventCreated) {
          onEventCreated();
        }
        window.alert('Event created successfully!');
      } else {
        const errorText = await response.text();
        setError(`Failed to create event: ${errorText || response.statusText}`);
      }
    } catch (err) {
      setError(`Failed to create event: ${err.message}`);
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <div className="mb-6">
      {!isExpanded ? (
        <button
          className="ff-button text-sm px-6 py-3 flex items-center gap-2"
          onClick={() => setIsExpanded(true)}
          style={{ backgroundColor: '#16a34a' }}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Create New Event
        </button>
      ) : (
        <div className="border-2 border-green-500/50 rounded-3xl p-6 bg-green-900/20">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold m-0 flex items-center gap-2">
              <svg
                className="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 4v16m8-8H4"
                />
              </svg>
              Create New Event
            </h3>
            <button
              className="text-gray-400 hover:text-white transition-colors"
              onClick={() => {
                setIsExpanded(false);
                setError(null);
              }}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <div className="flex items-center gap-3">
                <label
                  htmlFor="new-event-title"
                  className="min-w-[80px] text-right text-sm font-medium"
                >
                  Title:
                </label>
                <input
                  id="new-event-title"
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="e.g., My Awesome Event"
                  className="flex-1 px-3 py-2 rounded-lg bg-gray-800 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-green-500"
                  disabled={isCreating}
                />
              </div>
            </div>

            {error && (
              <div className="mb-4 p-3 rounded-lg bg-red-500/20 border border-red-500/50 text-red-300 text-sm">
                {error}
              </div>
            )}

            <div className="flex justify-center gap-3">
              <button
                type="button"
                className="ff-button text-sm px-4 py-2"
                onClick={() => {
                  setIsExpanded(false);
                  setError(null);
                }}
                disabled={isCreating}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="ff-button text-sm px-6 py-2 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={isCreating || !title.trim()}
                style={{ backgroundColor: '#16a34a' }}
              >
                {isCreating ? (
                  <span className="flex items-center gap-2">
                    <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                        fill="none"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      />
                    </svg>
                    Creating...
                  </span>
                ) : (
                  'Create Event'
                )}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default AddNewEvent;
